@let claims = $claims();
@if (claims) {
<mat-tree #navTree [dataSource]="dataSource()" [childrenAccessor]="childrenAccessor" class="nav-tree">

  <mat-tree-node *matTreeNodeDef="let node" [routerLink]="node.route"
    routerLinkActive="active" matTreeNodePadding>
    <div class="app-column app-center full-width">
      <mat-icon matListIcon>{{ node.icon }}</mat-icon>
      <div>{{node.name}}</div>
    </div>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding (click)="toggle(node)"
    [isExpandable]="true" [isExpanded]="expandedNode === node"
    (expandedChange)="expandedNode = $event ? node : (expandedNode === node ? null : expandedNode);" animate [ngClass]="{
      'active': isParentActive(node),
      'expanded': expandedNode === node,
    }">
    <div class="app-column app-center full-width">
      <mat-icon matListIcon>{{ node.icon }}</mat-icon>
      <div>{{node.name}}</div>
    </div>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when: isSectionTitle" class="section-title-leaf-node fade-in-animation">
    <div class="full-width" style="text-align: center;">{{node.name}}</div>
  </mat-tree-node>

  <mat-tree-node *matTreeNodeDef="let node; when: isLeafNode" class="leaf-node fade-in-animation"
    [routerLink]="node.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: !!node.exactActive }">
    <div class="app-row full-width" style="justify-content: space-between; align-items: center;">
      <div style="padding-left: 5px;">{{node.name}}</div>
    </div>
  </mat-tree-node>

</mat-tree>
} @else {
<mat-nav-list>
  <a mat-list-item routerLink="auth/signin" routerLinkActive="active">
    <div class="app-column app-center full-width">
      <mat-icon matListIcon>login</mat-icon>
      <div>Login</div>
    </div>
  </a>
</mat-nav-list>
}

<ng-template #signin>
  <mat-nav-list>
    <a mat-list-item routerLink="auth/signin" routerLinkActive="active">
      <div class="app-column app-center full-width parent-node-text">
        <mat-icon matListIcon>login</mat-icon>
        <div>Login</div>
      </div>
    </a>
  </mat-nav-list>
</ng-template>